import { AnimatePresence, motion } from 'framer-motion';
import Backdrop from '../Backdrop';
import { FC, PropsWithChildren, useEffect } from 'react';
import styles from './Modal.module.scss';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
}

const dropIn = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: '100vh',
    opacity: 0,
  },
};

const Modal: FC<PropsWithChildren<ModalProps>> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (isOpen) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";

      return () => {
        document.body.style.overflow = prevOverflow || "unset";
      };
    } else document.body.style.overflow = "unset";
  }, [isOpen]);

  return (
    <AnimatePresence mode="wait" initial={false} onExitComplete={() => null}>
      {isOpen && (
        <Backdrop onClick={onClose}>
          <motion.div
            onClick={(e) => e.stopPropagation()}
            variants={dropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={styles.modal}
          >
            {children}
          </motion.div>
        </Backdrop>
      )}
    </AnimatePresence>
  );
};

export default Modal;
